import axios from "axios";
import storageUtils from "../utils/storageUtils";
import { BASE, CLIENT_ID, CLIENT_SECRET } from "../config/config";

// 创建一个 axios 实例
const http = axios.create({
  baseURL: BASE, // 设置 API 地址
  timeout: 5000, // 设置请求超时时间
});

// 请求拦截器，在发送请求前执行
http.interceptors.request.use(
  config => {
    // 如果用户已登录，将 access_token 添加到请求头中
    const user = storageUtils.getUser();
    if (user && user.access_token) {
      config.headers["Authorization"] = `Bearer ${user.access_token}`;
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

// 刷新 access_token
async function refreshAccessToken() {
  // 获取用户信息
  const user = storageUtils.getUser();
  console.log(user,"userref");
  if (!user) return Promise.reject("用户未登录");

  // 获取 refresh_token
  const { refresh_token } = user;
  const data = {
    client_id: CLIENT_ID,
    client_secret: CLIENT_SECRET,
    grant_type: "refresh_token",
    refresh_token,
  };

  try {
    // 发送刷新 access_token 的请求
    const response = await http.post("/oauth2/login", data);
    // 将新的用户信息保存到本地存储中
    console.log(response.data,"response.data");
    storageUtils.saveUser(response.data);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

// 响应拦截器，在接收到响应时执行
http.interceptors.response.use(
  response => {
    return response.data; // 返回响应数据
  },
  async error => {
    const { status } = error.response;
    const user = storageUtils.getUser();

    // 如果响应状态码为 401（未授权）且用户已登录且有 refresh_token
    if (status === 401 && user && user.refresh_token) {
      try {
        // 刷新 access_token
        await refreshAccessToken();
        // 重新发送请求
        return http.request(error.config);

      } catch (error) {
        // 刷新失败，移除用户信息并跳转到登录页面
        storageUtils.removeUser();
        window.location.href = "/login";
        return Promise.reject(error);
      }
    }
    return Promise.reject(error);
  }
);

export { http };
